// extracted by mini-css-extract-plugin
export default {"table":"CourseCards_table__csms0"};